import React, { useState } from "react";
import { ReactComponent as Direct } from "asset/menu/direct.svg";

function ListItem({ title, description, type, onClick }) {
  const [isHover, setIsHover] = useState(false);

  return (
    <div
      className={
        isHover ? "main-content-" + type + " hover" : "main-content-" + type
      }
      id="openNow"
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={onClick}
    >
      <div
        className="main-content-instant-before"
        style={{
          display: isHover ? "none" : "block",
        }}
      >
        <div className="pointArea">
          <div className="point"></div>
        </div>
        <div className="btn-text-en">
          <span>{title?.en}</span>
        </div>
        <div className="btn-text-ko">
          <span>{title?.ko}</span>
        </div>
        <img src={process.env.REACT_APP_CLIENT_URL + "sample/plus.png"} alt="plus" />
      </div>

      <div
        className="main-content-instant-after"
        style={{
          display: isHover ? "block" : "none",
        }}
      >
        <div className="content-titleArea">
          <div className="content-title">
            <div className="btn-text-en-hover">
              <span>{title?.en}</span>
            </div>
            <div className="btn-text-ko-hover">
              <span>{title?.ko}</span>
            </div>
          </div>
          <div className="btn-direct">
            <Direct />
          </div>
        </div>
        <div className="content-explainArea">
          <span>{description}</span>
        </div>
      </div>
    </div>
  );
}

export default ListItem;
